import { commonUtils } from './common_utils';
import './native_share';
import { articleImageSlider } from './article_inline_image_slider';

const article = {
    loadMoreArticles() {
        let $loadMoreElement = $('.loadMoreData');
        let pageNo = $loadMoreElement.data('page-no');

        let urlWithParams = Routing.generate('ajax_article_list', {
            page: pageNo,
            make_id: $loadMoreElement.data('make-id'),
            type_id: $loadMoreElement.data('type-id'),
        });
        $.get(urlWithParams, function (data) {
            $('#moreArticleData').append(data);
            $(`#loadMoreData_${pageNo}`).remove();
        });
    },
    getArticleByMake(make) {
        let action = $('.articleMakeForm').attr('action');
        let seoMake = make.find(':selected').data('seo-name');
        seoMake = typeof seoMake !== 'undefined' ? seoMake : '';
        window.location.href = `${action}/${seoMake}`;
    },
    getArticleByType(type) {
        let action = $('.articleTypeForm').attr('action');
        let seoType = type.find(':selected').data('seo-name');
        seoType = typeof seoType !== 'undefined' ? seoType : '';
        window.location.href = `${action}/${seoType}`;
    },
};

$(function () {
    let $document = $(document);

    articleImageSlider.init();

    // to load more articles in article category page
    $document.on('click', '#loadMore', function () {
        article.loadMoreArticles();
        this.remove();
    });

    // to list article based on article make filter
    $document.on('change', '.articleMake', function () {
        article.getArticleByMake($(this));
    });

    // to list article based on article type filter in mobile site
    $document.on('change', '.articleType', function () {
        article.getArticleByType($(this));
    });

    // to display facebook comment section in article listing page
    $('.social-share-box__facebook-comment').click(function (event) {
        event.preventDefault();
        commonUtils.scrollToElement('articleDetailComment');
    });
});
